<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg3720"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs3724"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath3734"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path3732" /></clipPath></defs><g
     id="g3726"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g3728"><g
         id="g3730"
         clip-path="url(#clipPath3734)"><g
           id="g3736"
           transform="translate(424,400)"><path
             d="m 0,0 v -370 c 0,-8.28 -6.72,-15 -15,-15 h -306 c -8.28,0 -15,6.72 -15,15 V 82 c 0,8.28 6.72,15 15,15 h 225"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3738" /></g><g
           id="g3740"
           transform="translate(424,400)"><path
             d="M 0,0 -96,97 V 0 H 0"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3742" /></g><g
           id="g3744"
           transform="translate(201.728,418.6338)"><path
             d="m 0,0 c 0,0 -11.991,11.06 -30.473,5.492 -16.971,-5.112 -21.186,-28.333 -9.653,-37.378 6.622,-5.194 16.586,-9.465 30.014,-14.211 30.055,-10.624 18.945,-53.008 -11.627,-53.213 -11.931,-0.079 -17.509,0.678 -27.989,7.535"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3746" /></g><g
           id="g3748"
           transform="translate(179.9907,303.8496)"><path
             d="M 0,0 V 15.471"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3750" /></g><g
           id="g3752"
           transform="translate(179.9907,425.6504)"><path
             d="M 0,0 V 14.35"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3754" /></g><g
           id="g3756"
           transform="translate(360,80)"><path
             d="M 0,0 H -56"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3758" /></g><g
           id="g3760"
           transform="translate(152,240)"><path
             d="M 0,0 H 208"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3762" /></g><g
           id="g3764"
           transform="translate(152,176)"><path
             d="M 0,0 H 208"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3766" /></g></g></g></g></svg>
</template>
